import { InfrastructureError } from '@goodt-wcore/errors';

export class ErrorManagerException extends InfrastructureError {}
